export default {
  title: 'Mes messages',
  receptionTab: 'Reçus',
  sendTab: 'Envoyés',
  sendMessageButton: 'Envoyer un message',
  headerObject: 'Objet',
  headerSubject: 'Sujet',
  headerReceived: 'Reçu',
  headerSent: 'Envoyé',
  messagesDeletedSnackbar_one: 'Message supprimé.',
  messagesDeletedSnackbar_many: '{{count}} messages supprimés.',
  noMessages: 'Aucun message',
  subjectAdditionalTitle: 'Autre :',
  labelCheckboxSelectAll: 'Sélectionner tout',
  labelCheckboxSelect: 'Sélectionner',
  messageRowAriaLabel: 'Sélectionner',
};
